module.exports = __webpack_public_path__ + "img/32291f427fb16f21f974d4dbef8f3dc8.png";